export default {
  name: 'SubCard',
  props: {
    title: String,
    colon: {
      type: Boolean,
      default: false
    }
  }
};